import React from 'react'
import { css, StyleSheet } from 'aphrodite'

const COMPANY = 'iAgro'
const SUPPORT_EMAIL = 'support@iagro.uz'

export default function Support() {
    return (
        <div className={css(styles.page)}>
            <div className={css(styles.container)}>
                <h1 className={css(styles.title)}>Yordam va aloqa</h1>
                <p className={css(styles.p)}>
                    {COMPANY} ilovasidan foydalanishda savol yoki muammo yuzaga kelsa,
                    biz bilan bog'laning. Imkon qadar tez javob berishga harakat qilamiz.
                </p>

                <div className={css(styles.card)}>
                    <div className={css(styles.row)}>
                        <span className={css(styles.label)}>Elektron pochta</span>
                        <a className={css(styles.link)} href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    </div>
                </div>

                <h2 className={css(styles.h2)}>Tez-tez beriladigan savollar</h2>

                <Faq q="Ro'yxatdan o'tish uchun nima kerak?">
                    Ro'yxatdan o'tish uchun ism, familiya, elektron pochta, parol va
                    administrator bergan taklif kodi kerak bo'ladi.
                </Faq>

                <Faq q="Hisobimni qanday o'chiraman?">
                    Ilovada <b>Sozlamalar → Akkauntni o'chirish</b> bo'limiga kiring.
                    Hisobingiz va unga bog'liq maʼlumotlar butunlay o'chiriladi.
                </Faq>

                <Faq q="Parolimni unutsam nima qilaman?">
                    Parolni tiklash uchun {SUPPORT_EMAIL} manziliga yozing yoki
                    administrator bilan bog'laning.
                </Faq>

                <p className={css(styles.footer)}>© 2026 {COMPANY}. Barcha huquqlar himoyalangan.</p>
            </div>
        </div>
    )
}

function Faq({ q, children }) {
    return (
        <div className={css(styles.faq)}>
            <h3 className={css(styles.faqQ)}>{q}</h3>
            <p className={css(styles.p)}>{children}</p>
        </div>
    )
}

const styles = StyleSheet.create({
    page: {
        minHeight: '100vh',
        backgroundColor: '#f8fafc',
        padding: '2rem 1rem',
    },
    container: {
        maxWidth: '760px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: '2.5rem',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
        color: '#0f172a',
        lineHeight: 1.7,
    },
    title: {
        fontSize: '2rem',
        fontWeight: 700,
        margin: '0 0 1rem',
        color: '#D97757',
    },
    p: { fontSize: '1rem', margin: '0 0 0.5rem' },
    card: {
        backgroundColor: '#FBEEE8',
        borderRadius: '12px',
        padding: '1.25rem',
        margin: '1.5rem 0',
    },
    row: { display: 'flex', flexDirection: 'column' },
    label: { fontSize: '0.85rem', color: '#64748b', marginBottom: '0.25rem' },
    link: { color: '#D97757', textDecoration: 'none', fontSize: '1.1rem', fontWeight: 600 },
    h2: { fontSize: '1.3rem', fontWeight: 600, margin: '1.5rem 0 1rem' },
    faq: { marginBottom: '1.25rem' },
    faqQ: { fontSize: '1.05rem', fontWeight: 600, margin: '0 0 0.25rem' },
    footer: { marginTop: '2rem', fontSize: '0.85rem', color: '#94a3b8', textAlign: 'center' },
})
